/**
 * @file 知识库文档 channel / file_type → 图标映射
 */
import tapdIcon from '../image/tapd.svg';
import iwikiIcon from '../image/iwiki.svg';
import linkIcon from '../image/link.svg';
import videoIcon from '../image/video.svg';
import imageIcon from '../image/image.svg';
import csvIcon from '../image/csv.svg';
import excelIcon from '../image/excel.svg';
import pdfIcon from '../image/pdf.svg';
import pptIcon from '../image/ppt.svg';
import wordIcon from '../image/word.svg';
import txtIcon from '../image/txt.svg';
import mdFileIcon from '../image/mdFile.svg';
import defaultDocIcon from '../image/defaultDoc.svg';
import knowledgeBaseIcon from '../image/knowledgeBase.svg';
import knowledgeBaseTextIcon from '../image/knowledgeBaseText.svg';

/** 知识库分组头图标 */
export const KB_ICON = knowledgeBaseIcon;

/** 知识库分组头文本图标 */
export const KB_TEXT_ICON = knowledgeBaseTextIcon;

/** channel → 图标映射 */
const CHANNEL_ICON_MAP: Record<string, string> = {
  tapd: tapdIcon,
  iwiki: iwikiIcon,
  link: linkIcon,
  web: mdFileIcon,
  video: videoIcon,
  image: imageIcon,
};

/** file_type → 图标映射 */
const FILE_TYPE_ICON_MAP: Record<string, string> = {
  csv: csvIcon,
  xlsx: excelIcon,
  xls: excelIcon,
  pdf: pdfIcon,
  ppt: pptIcon,
  pptx: pptIcon,
  doc: wordIcon,
  docx: wordIcon,
  txt: txtIcon,
  md: mdFileIcon,
};

/**
 * 根据 channel 和 file_type 获取对应的图标
 * 优先按 channel 匹配，匹配不到时按 file_type 匹配，最终兜底 defaultDoc
 */
export const getChannelIcon = (channel?: string, fileType?: string): string => {
  if (channel && CHANNEL_ICON_MAP[channel]) {
    return CHANNEL_ICON_MAP[channel];
  }
  if (fileType && FILE_TYPE_ICON_MAP[fileType.toLowerCase()]) {
    return FILE_TYPE_ICON_MAP[fileType.toLowerCase()];
  }
  return defaultDocIcon;
};
